/**
 * 运营中心 - 简体中文
 */
export default {
  title: '运营中心',
  equipmentManagement: '设备管理',
  barterManage: '换货管理',
  freightFees: '运费',
  payment: '支付',
  purchaseOrderNo: '采购单号',
  orderTime: '下单时间',
  purchaseQty: '采购量',
  purchaseAmount: '采购金额',
  paidAmount: '实付金额',
  freightPlan: '运费方案',
  planOne: '方案一: 运费到付',
  planTwo: '方案二: 运费预付',
  payFreightCollect: '支付(运费到付)',
  payFreightPrepaid: '支付(运费预付)',
  cloudWarehouseManagement: '云仓管理',
  purchasingManagement: '采购管理',
  partner: '合伙人',
  channelAgents: '渠道代理',
  // 运费弹窗
  unit: '台',
  yuan: '元',
  planOneDesc: '（收货后支付给配送员，实际金额可能会有20%的浮动，以实际为准）',
  planTwoDesc: '（原价{original}元，与订货款一起支付，出现争议由总部负责）',
  chargeItem: '收费项目',
  unitPrice: '单价',
  quantity: '数量',
  amount: '金额',
  discount: '折扣',
  amountAfterDiscount: '优惠后的金额',
  orderFreightTipIntro: '本订单采购数量不足10台，按公司快递规则是: 到付;为了让大家享受邮费打折的优惠，现提供预付到付运费的服务，请注意:',
  freightRule1: '1、到付运费折扣以公司与京东仓签订的折扣为准，目前折扣: 6.5折，以后如有变化，会及时通知;',
  freightRule2: '2、预收到付运费自愿选择，如果放弃预付运费所享受的折扣，须在签收时支付到付运费给快递公司，具体支付金额和方式以快递公司为准;',
  freightRule3: '3、预收到付运费收取后，如果此订单与其他订单合并配送，满足免运费条件(数量大于等于10台)，完成后，自动退还预收运费;',
  premium: '保费',
  doNotOperateTooFrequently: '请勿操作过于频繁',
  paymentFailed: '付款失败',
  // 换货管理列表与弹窗
  addBarter: '新增换货',
  operation: '操作',
  deliver: '发货',
  more: '更多',
  confirmReceipt: '收货确认',
  modify: '修改',
  audit: '审核',
  cancelConfirm: '取消确认',
  barterOrderNo: '换货单号',
  shipInProductName: '换入商品名称',
  shipInQty: '换入商品数量',
  shipOutProductName: '换出商品名称',
  shipOutQty: '换出商品数量',
  barterPriceDiff: '换货差价',
  cancelConfirmTip: '是否确认取消，一旦取消后，该换货申请将作废，不可恢复，如需要可以重新创建换货申请！',
  payDeductTip: '本次支付将扣除：',
  cashAccount: '现金账户',
  goldAccount: '金账户',
  deliveryVoucherAccount: '提货券帐户',
  gotIt: '我知道了',
  paySuccessTitle: '支付成功',
  payFailTitle: '支付失败',
  paySuccessAmount: '成功支付￥{money}元',
  payFailAmount: '未能成功支付￥{money}元',
  cancelSuccess: '取消成功',
  tip: '提示',
  // 换货列表表头与搜索（与 config 对应）
  barterStatus: '换货状态',
  priceDiffAmount: '应补差价金额',
  prepaidFreight: '预付运费',
  receivedAmount: '已支付金额',
  payStatus: '支付状态',
  remark: '备注',
  applyAgentId: '申请代理商ID',
  applyAgentName: '申请代理商名称',
  shipOutProductNameCol: '换出商品名称',
  shipOutProductQty: '换出商品数量',
  productLevel: '单价级别',
  shipOutShipStatus: '换出商品发货状态',
  swapAgentId: '换货代理商ID',
  swapAgentName: '换货代理商名称',
  shipInProductNameCol: '换入商品名称',
  shipInProductQty: '换入商品数量',
  shipInShipStatus: '换入商品发货状态',
  submitTime: '提交时间',
  auditUser: '审核人',
  auditTime: '审核时间',
  createUser: '创建人',
  createTime: '创建时间',
  placeholderBarterOrderNo: '请输入换货单号',
  applyAgent: '申请代理商',
  placeholderApplyAgent: '请选择代理商',
  swapAgent: '换货代理商',
  placeholderSwapAgent: '请选择换货代理商',
  self: '本人',
  placeholderBarterStatus: '请选择换货状态',
  shipOutStatus: '换出商品发货状态',
  shipInStatus: '换入商品发货状态',
  barterProductName: '商品名称',
  placeholderBarterProductName: '请输入商品名称',
  productName: '商品名称',
  placeholderProductName: '请输入商品名称',
  applyReceiveWarehouse: '申请方收货仓库',
  placeholderApplyWarehouse: '请选择申请方收货仓库',
  swapReceiveWarehouse: '换货方收货仓库',
  placeholderSwapWarehouse: '请选择换货方收货仓库',
  cloudOrderNo: '云仓发货单号',
  placeholderCloudOrderNo: '请输入云仓发货单号',
  expressNo: '快递单号',
  placeholderExpressNo: '请输入快递单号',
  placeholderCreateTime: '创建时间',
  placeholderSubmitTime: '提交时间',
  placeholderAuditTime: '审核时间',
  placeholderPayStatus: '请选择支付状态',
  to: '至',
  // 发货弹窗
  applyShipWarehouse: '申请方发货仓库',
  swapShipWarehouse: '换货方发货仓库',
  applyReceiveWarehouseLabel: '申请方收货仓库',
  swapReceiveWarehouseLabel: '换货方收货仓库',
  applyReceiver: '申请方收货人',
  swapReceiver: '换货方收货人',
  receiverPhone: '收货人电话',
  provinceCityDistrict: '省市区',
  detailAddress: '详细地址',
  shipOutExpressNo: '换出商品快递单号',
  shipInExpressNo: '换入商品快递单号',
  placeholderSelectWarehouse: '请选择收货仓库',
  placeholderProductExpressNo: '请输入商品快递单号',
  transferUnselected: '待选',
  transferSelected: '已选',
  placeholderSnCode: '请输入SN码',
  snCode: 'SN码',
  productNameLabel: '商品名称',
  // 收货确认弹窗
  shipInLabel: '换入',
  shipOutLabel: '换出',
  receiveConfirmTitle: '商品收货确认',
  productExpressNo: '商品快递单号',
  productShipStatus: '商品发货状态',
  cloudShipOrderNo: '云仓发货单号',
  confirmReceiveCheck: '收货确认：型号、数量SN码完全一致',
  refuseAccept: '拒绝接受',
  placeholderRefuseReason: '请输入拒绝原因',
  receiveConfirmTip: '一旦收货确认，换货商品sn码将转入换货方，且不可退回！',
  pleaseCheckItem: '请勾选核对项！',
  pleaseFillRefuseReason: '请填写拒绝原因！',
  // 付款/对公转账弹窗
  priceDiffAmountLabel: '应补差价金额',
  freightLabel: '运费',
  relatedAgent: '关联代理商',
  accountBalance: '账户余额',
  relatedAgentBalance: '关联代理账户余额',
  availableAmount: '可用金额',
  remainingPayAmount: '剩余支付金额',
  payMethod: '支付方式',
  bankTransfer: '对公转账',
  transferAmount: '转账金额',
  payTime: '支付时间',
  payTimeRequired: '支付时间不能为空',
  selectPayTime: '请选择支付时间',
  paySerialNo: '支付流水',
  placeholderPaySerialNo: '请输入支付流水',
  payVoucher: '支付凭证',
  payVoucherRequired: '支付凭证不能为空',
  voucherTip: '支持jpg/png格式，最佳尺寸1080x1920，大小不超过5MB',
  voucherExample: '凭证实例',
  bankAccount: '银行账号',
  openingBank: '开户行',
  payRemark: '支付备注',
  placeholderPayRemark: '请输入支付备注',
  // 微信/支付宝付款
  payAmountYuan: '支付{amount}',
  qrcodeGenerating: '二维码生成中...',
  scanWithAlipay: '使用支付宝扫一扫',
  scanWithWechat: '使用微信扫一扫',
  qrcodeUrlInvalid: '二维码地址不正确',
  // 换货详情/申请
  placeholderRemark200: '请输入200字以内的备注信息',
  auditRemark: '审核备注',
  applyInfo: '申请信息',
  // 换货详情 information.vue
  receiveWarehouse: '收货仓库',
  receiver: '收货人',
  placeholderDetailAddress: '请输入详细地址',
  shipStatus: '发货状态',
  addSelectShipOutProduct: '+选择换出商品',
  addSelectShipInProduct: '+选择换入商品',
  shipOutTotalAmount: '换出商品合计金额：',
  shipInTotalAmount: '换入商品合计金额：',
  swapInfo: '换货信息',
  swapAgentLabel: '换货代理商',
  productLevelName: '单价级别',
  selectShipOutProduct: '选择换出商品',
  selectShipInProduct: '选择换入商品',
  shipOutProductModel: '换出商品型号',
  shipInProductModel: '换入商品型号',
  placeholderSelectProductModel: '请选择商品型号',
  diffPriceNoMerge: '**不同单价的商品，不可合并换货**',
  productSwapableQty: '商品可换数量：',
  swapQty: '换货数量',
  placeholderEnterQty: '请输入数量',
  priceDiffAmountLabelBottom: '应补差价金额：',
  auditOpinion: '审核意见',
  auditResultLabel: '审核结果：',
  agree: '同意',
  refuse: '拒绝',
  placeholderAuditOpinion100: '请输入100字以内的审核意见',
  applySide: '申请方',
  swapSide: '换货方',
  enterReceiver: '请输入{type}收货人',
  enterReceiverPhone: '请输入{type}收货人电话',
  selectProvinceCityDistrict: '请选择{type}省市区',
  enterDetailAddress: '请输入{type}详细地址',
  enterReceiverShort: '请输入收货人',
  enterReceiverPhoneShort: '请输入收货人电话',
  selectProvinceCityDistrictShort: '请选择省市区',
  enterDetailAddressShort: '请输入详细地址',
  pleaseSelectShipOut: '请选择换出商品',
  pleaseSelectShipIn: '请选择换入商品',
  chooseProductTitle: '商品',
  warehouseMustMatch: '换入/换出的收货仓库必须保持一致，如果是云仓，请保持同地的云仓！',
  priceDiffMustBeValid: '应补款金额必须低于换出商品的单价，且大于等于0，请调整交换商品的数量后重新保存',
  hqBarterDiffZero: '与总部换货"总部回购商品"，应补差价必须为0',
  selectAuditResult: '请选择审核结果',
  enterAuditOpinion: '请输入审核意见',
  swapQtyMin1: '换货数量不能小于1',
  swapQtyMaxExceed: '换货数量不能大于该商品在该仓库的可换数量',
  pleaseSelectToSelected: '请选择设备到已选区！',
  diffModelOrPriceNoMerge: '不同型号或单价的商品不可合并换货',
  confirmChangeWarehouseApply: '收货仓库改变，下方已选择的换出商品将全部清空，请重新选择，是否继续修改收货仓库！',
  confirmChangeWarehouseSwap: '收货仓库改变，下方已选择的换入商品将全部清空，请重新选择，是否继续修改收货仓库！',
  confirmChangeCampus: '换货代理商改变，下方已选择的换入商品将全部清空，请重新选择，是否继续修改换货代理商！',
  eclpOrderNo: '云仓单号',
  unitPriceLabel: '单价：',
  // 发货弹窗 deliverGoods
  shipOutDeliverTitle: '换出商品发货',
  shipInDeliverTitle: '换入商品发货',
  pleaseEnterFullExpressNo: '请输入完整快递单号',
  deliverSuccess: '发货成功',
  qtyNotMatchShipIn: '与换入商品数量不一致',
  // 支付 payment
  selectPayMethodForRemaining: '请选择以下支付方式支付剩余金额',
  insufficientBalanceRecharge: '账户余额不足，请先去充值。',
  // 对公转账 publicTransfer
  paySuccess: '付款成功',
  imageFormatJpgPng: '图片只能是 JPG/PNG 格式!',
  imageSizeMax5M: '图片大于5M，请压缩后上传!',
  confirmRemoveFile: '确定移除 {name}？',
  // 微信/支付宝 wxOrZfbPay
  alipay: '支付宝',
  wechatPay: '微信支付',
  // 订阅卡 SubscriptionCard
  subscriptionCardManage: '订阅卡管理',
  copyCardNo: '复制订阅卡号',
  copyCardPassword: '复制订阅密码',
  extendValidity: '延长有效期',
  markValid: '标记有效',
  void: '作废',
  confirmExtend30Days: '确定要延长30天的订阅卡有效期吗？',
  confirmMarkVoid: '确定要将订阅卡标记作废吗？',
  confirmMarkValid: '确定要将订阅卡标记有效吗？',
  agentId: '代理商ID',
  agentName: '代理商名称',
  placeholderAgent: '请选择代理商',
  subscriptionCardType: '订阅卡类型',
  subscriptionCardNo: '订阅卡卡号',
  subscriptionCardStatus: '订阅卡状态',
  returnApplyStatus: '返还申请状态',
  purchaseTime: '购买时间',
  validDate: '有效日期',
  copySuccess: '复制成功',
  copyFailed: '复制失败！',
  extendSuccess: '延期成功',
  extendFailed: '延期失败',
  voidSuccess: '作废成功',
  voidFailed: '作废失败',
  markValidSuccess: '标记有效成功',
  markValidFailed: '标记有效失败',
  cancelSuccessShort: '取消成功',
  cancelFailed: '取消失败',
  // 订阅卡 config 占位等
  placeholderCardNo: '请输入订阅卡卡号',
  placeholderCardStatus: '请选择订阅卡状态',
  buyTimeLabel: '购买日期',
  validTimeLabel: '有效日期',
  returnApplyStatusLabel: '返还状态申请',
  placeholderReturnApplyStatus: '请选择返还状态申请',
  notApply: '不可申请',
  pendingApply: '待申请',
  applied: '已申请',
  rangeTilde: ' ~ ',
  // 云仓 CloudWarehouse
  totalStock: '总库存',
  availableStock: '可用库存',
  warehouseLabel: '仓库',
  placeholderWarehouse: '请选择仓库',
  productNameCol: '商品名称',
  warehouseNameCol: '仓库名称',
  // 首单奖励 FirstReward
  orderNoLabel: '采购单号',
  placeholderOrderNo: '请输入采购单号',
  dispatchTimeLabel: '发货时间',
  placeholderDispatchTime: '请选择发货时间范围',
  settleYearMonthLabel: '结算年月',
  placeholderSettleYearMonth: '请选择结算年月',
  introduceCustomId: '转介绍客户ID',
  introduceCustomName: '转介绍客户名称',
  contractAmount: '转介绍签约金额',
  orderStatusName: '订单状态',
  productName: '产品名称',
  buyNum: '采购数量',
  receiveNum: '发货数量',
  productPrice: '采购单价',
  orderAmount: '采购总金额',
  orderContractAmount: '合同款支付金额',
  totalContractAmount: '累计合同款金额',
  lastDispatchTime: '发货时间',
  rewardRateStr: '奖励比例',
  rewardAmount: '奖励金额',
  totalRewardAmount: '累计奖励金额',
  monthCol: '结算年月',
  introduceCampusId: '战略/事业合伙人ID',
  introduceCampusName: '战略/事业合伙人名称',
  payStatusName: '支付状态',
  exportBtn: '导出',

  // 转介绍客户 IntroduceCustomer
  introduceCustomerLabel: '转介绍客户',
  placeholderIntroduceCustomer: '请选择转介绍客户',
  agentTypeLabel: '代理商类型',
  placeholderAgentType: '请选择代理商类型',
  areaLabelPartner: '所在省市区',
  placeholderArea: '请选择所在省市区',
  accountActivationTimeLabel: '账号首次激活时间',
  placeholderAccountActivationTime: '请选择账号激活时间范围',
  agentLevelName: '代理商级别',
  contractMoney: '转介绍签约金额',
  firstContractAmount: '首笔合同款充值金额',
  firstContractTotalAmount: '首笔合同款累计支付金额',
  activateTimeCol: '账号首次激活时间',
  orderNoLabelShort: '采购单号',
  placeholderOrderNoShort: '请输入采购单号',
  renewPayAmount: '续费支付金额',

  // 渠道代理首单奖励 AgentFirstPaymentReward
  placeholderMonth: '请选择月份',
  isFirstRewardLabel: '是否首次',
  placeholderStatus: '请选择状态',
  firstReward: '首次',
  supplementReturn: '补返',
  contractPaidAmount: '已付合同款金额',
  sumReturnAmount: '累计已返金额',
  introducerName: '转介绍客户名称',
  regionAgentId: '区代ID',
  shareAmount: '区代分担金额',
  channelAgentName: '渠道代名称',
  introduceAgentId: '介绍人/渠道代ID',

  // 双重订单 DoubleOrder
  addDoubleOrder: '新增双重订单',
  sendDeliveryVoucher: '发提货券',
  submit: '提交',
  changeAddress: '变更地址',
  invoiceConfirm: '发票确认',

  // 区域客户 RegionCustomers
  introduceCustomIdLabel: '转介绍客户ID',
  placeholderIntroduceCustomId: '请选择转介绍客户ID',
  accountOpenTimeLabel: '账户开通时间',
  introducerLevelLabel: '介绍人当前渠道代级别',
  placeholderLevel: '请选择级别',
  openTimeCol: '账户开通时间',
  usedAmount: '已下单金额',
  firstContractRatioStr: '首笔合同款奖励比例',
  cumulativeLevelValue: '累计渠道代级别',
  introducerId: '介绍人id',
  introducerNameCol: '介绍人名称',

  // 返佣与费用 RebatesAndFees
  purchaseNo: '采购单号',
  sendNum: '发货数量',
  purchaseTotalAmount: '采购总金额',
  renewOrderPayAmount: '续费货款支付金额',
  sendTimeCol: '发货时间',
  unitSubscriptCostAmount: '订阅费金额',
  rewardRateCol: '奖励系数',
  rewardGrantFlagVO: '是否已发奖励',
  subscriptionFeeRebateAmount: '订阅费返佣',
  addServiceFeeAmount: '增值服务费',
  shareSubscriptionFee: '区代分担订阅费返佣',
  shareAddServiceFee: '区代分担增值服务费',

  // 报备复核 ReportConfirm
  reviewBtn: '复核',
  detailBtn: '详情',

  // 下级合伙人档案 SubPartnerProfile
  partnerIdLabel: '合作伙伴ID',
  placeholderPartnerId: '请填写合作伙伴ID',
  locationLabel: '所在地',
  placeholderLocation: '请选择所在地',
  partnerName: '合作伙伴名称',
  locationCol: '所在地',
  contactName: '联系人姓名',
  contactPhone: '联系人电话',
  upperAgentId: '上级代理商ID',
  upperAgentName: '上级代理商名称',
  firstActiveTime: '账号首次激活时间',
  profileDetail: '档案详情',

  // 跨区域申诉 CrossRegionalReview
  snCodeLabel: '设备SN码',
  placeholderSnCode: '请输入设备SN码',
  dealerLabel: '经销商',
  placeholderDealerName: '请输入经销商名称',
  appealStatusLabel: '申诉状态',
  placeholderAppealStatus: '请选择申诉状态',
  appealTimeLabel: '申诉时间',
  placeholderAppealTime: '请选择申诉时间范围',
  appealPending: '待审核',
  appealApproved: '审核通过',
  appealRejected: '审核驳回',
  deviceModel: '设备型号',
  dealerAddress: '经销商所在地',
  activeTimeCol: '软件激活时间',
  activeProvinceCity: '软件激活省市区',
  crossActiveDate: '跨区域活跃日期',
  crossActiveProvinceCity: '跨区域活跃省市区',
  crossRegionalSubmitterCol: '提交方',
  appealStatusName: '申诉状态',
  appealSubmitTime: '申诉提交时间',
  auditTimeCol: '审核时间',
  auditUser: '审核人',
  auditBtn: '审核',
  viewDetail: '查看详情',
  crossAppealTitle: '跨区域活跃设备申诉',
  dealerIdCol: '经销商ID',
  campusNameCol: '经销商名称',
  machineSnLabel: '学习机sn码：',
  dealerAddressLabel: '经销商所在地：',
  activeProvinceCityLabel: '软件激活省市：',
  activeProvinceCityDialog: '软件激活省市',
  crossActiveProvinceCityLabel: '跨区域活跃省市区：',
  appealContentLabel: '申请说明：',
  proofMaterialLabel: '证明材料：',
  remarkLabel: '备注：',
  placeholderRemarkReject: '当选择驳回时必填，2~20字',
  placeholderSelectShort: '请选择',
  ruleRemarkLength: '驳回备注需2~20字',
  auditSuccess: '审核成功',
  crossReviewSectionBasic: '基础信息',
  crossReviewSectionYearStats: '近一年统计',
  crossReviewSectionAppeal: '申诉材料',
  crossReviewSectionAudit: '审核信息',
  crossReviewMachineSn: '学习机SN码',
  crossReviewPastYearActivate: '过往一年激活数量',
  crossReviewPastYearCrossActive: '过往一年跨省市活跃数量',
  crossReviewPastYearLocked: '过往一年跨省市活跃已锁定数量',
  crossReviewPastYearCities: '过往一年跨省市活跃涉及省市',
  crossReviewNoProof: '暂无证明材料',
  auditResultFormLabel: '审核结果',
  selectAuditResultRule: '请选择审核结果',
  appealDescription: '申请说明',
  proofMaterials: '证明材料',

  // 运营联系方式 ContactConfig
  contactWayNameLabel: '运营联系方式名称：',
  placeholderContactWayName: '请输入运营联系方式名称',
  placeholderContactName: '请输入联系人姓名',
  contactLevelLabel: '联系方式级别：',
  placeholderContactLevel: '请选择联系方式级别',
  provinceLevel: '省级',
  cityLevel: '市级',
  districtLevel: '区级',
  applicableRegionLabel: '适用区域：',
  placeholderApplicableRegion: '请选择适用区域',
  lastEditTime: '最后编辑时间',
  lastEditor: '最后编辑人',
  applicableRegionDesc: '适用区域',
  addContactConfig: '新增运营联系方式',
  operationRemind: '操作提醒',
  confirmDeleteContact: '确定要删除此条联系人信息吗？',
  contactNameLabel: '联系人姓名：',
  phoneLabel: '手机号：',
  placeholderPhone: '请输入手机号',
  weChatIdLabel: '微信号：',
  placeholderWeChatId: '请输入微信号',
  emailLabel: '邮箱：',
  placeholderEmail: '请输入邮箱',
  otherContactLabel: '其他联系方式：',
  placeholderOtherContact: '请输入其他联系方式',
  placeholderSelectLevel: '请选择级别',
  placeholderProvinces: '请选择省市区',
  addContactTitle: '新增运营联系方式',
  editContactTitle: '编辑运营联系方式',
  ruleContactWayNameRequired: '请输入运营联系方式名称',
  ruleContactWayNameLength: '名称长度在2到20个字符之间',
  ruleContactLevelRequired: '请选择级别',
  ruleProvincesRequired: '请选择省市区',
  ruleContactNameRequired: '请输入联系人姓名',
  ruleContactNameLength: '联系人姓名长度在2到20个字符之间',
  ruleContactNameFormat: '联系人姓名仅支持中文、英文和"·"',
  rulePhoneFormat: '请输入正确的手机号',
  ruleWeChatIdFormat: '微信号必须以字母或者下划线开头，可以使用6-20位数字、字母、下划线、减号或它们的组合。',
  ruleEmailFormat: '请输入正确的邮箱',
  atLeastOneContact: '请输入至少1种联系方式',
  editSuccess: '编辑成功',
  addSuccess: '新增成功',
  deleteSuccess: '删除成功',

  // 区代京东仓发货 AreaJdSend
  agent: '代理商',
  dispatchOrderNo: '发货单号',
  placeholderDispatchOrderNo: '请输入发货单号',
  createTimeLabel: '创建时间',
  jdProductNameLabel: '京东商品名称',
  placeholderJdProductName: '请输入京东商品名称',
  orderDeliveryStatus: '订单发货状态',
  placeholderOrderDeliveryStatus: '请选择订单发货状态',
  receiverInfo: '收货人信息',
  placeholderReceiverInfo: '请输入收货人信息',
  dispatchWarehouse: '发货仓',
  placeholderDispatchWarehouse: '请选择发货仓',
  dispatchCloudWarehouse: '发货云仓',
  placeholderDispatchCloudWarehouse: '请选择发货云仓',
  relatedOrder: '关联订单',
  placeholderRelatedOrder: '请输入关联订单',
  waybillNo: '物流单号',
  placeholderWaybillNo: '请输入物流单号',
  cloudOutboundNo: '云仓出库单号',
  placeholderCloudOutboundNo: '请输入云仓出库单号',
  warehouseTypeName: '发货云仓',
  ckOrderNo: '发货单号',
  orderDeliveryStatusVO: '订单发货状态',
  eclpSoNo: '云仓出库单号',
  waitSendNum: '待发货数量',
  agentWarehouseName: '代理商收货仓',
  receiverName: '收货人',
  receiverMobile: '收货人手机',
  provinceName: '省市区',
  receiverAddress: '收货人地址',
  warehouseName: '发货仓',
  purchaseNosFormat: '关联订单',
  createTime: '创建时间',
  sendTime: '发货时间',
  cancelDispatch: '取消发货',
  confirmCancelDispatch: '确认取消发货单？',
  agentIdCol: '代理商ID',
  agentNameCol: '代理商名称',
  sendNumCol: '已发货数量',
  logisticsCompany: '物流公司',
  logisticsNo: '物流单号',
  confirmCancelDispatchShort: '确认取消发货吗?',

  // 区域发货 AreaConsignment
  consignmentOrderNo: '订单编号',
  placeholderConsignmentOrderNo: '请输入订单编号',
  dispatchRegionAgent: '发货区域代理',
  productTypeLabel: '商品类型',
  placeholderProductType: '请选择商品类型',
  expressNoLabel: '快递单号',
  placeholderExpressNo: '请输入快递单号',
  dispatchStatusLabel: '发货状态',
  placeholderDispatchStatus: '请选择发货状态',
  statusValid: '有效',
  statusCancelled: '已取消',
  dkOrderNoLabel: '调拨单号',
  placeholderDkOrderNo: '请输入调拨单号',
  pnOrderNoLabel: '提货单号',
  placeholderPnOrderNo: '请输入提货单号',
  snCodePlaceholder: '请输入设备SN码',
  snCodeCol: '设备SN码',
  areaConsignmentProductNameCol: '商品名称',
  productNameCol: '商品名称',
  campusIdCol: '代理商ID',
  campusNameCol: '代理商名称',
  orderNoCol: '订单编号',
  dkOrderNoCol: '调拨单号',
  pnOrderNoCol: '提货单号',
  dispatchDate: '发货日期',
  expressName: '物流公司',
  expressNoCol: '快递单号',
  expressStateName: '物流状态',
  isDeleteName: '发货状态',
  accountStatusName: '账户状态',
  useStatusName: '设备状态',
  regionCampusIdCol: '发货区代ID',
  cancelByName: '取消人',
  cancelTimeCol: '取消时间',
  regionCampusNameCol: '发货区代名称',
  headOfficeProductNameCol: '商品名称',
  headOfficeOrderQuantityCol: '订单数量',
  headOfficeSendQuantityCol: '发货数量',
  headOfficeOrderAmountCol: '订单金额',
  headOfficeIsAutoOrderCol: '是否自动订单',
  headOfficeTmallOrderNoCol: '天猫订单编号',

  // 采购 Purchasing / 赊货 Creditorders
  addPurchase: '新增采购',
  addCreditOrder: '新增赊货订单',
  provinceAudit: '省代审核',
  creditOrderTip: '订单创建后可以暂不付款或者部分付款，具体要求详见：',
  viewDetailLink: '查看详情',
  invoiceConfirmTip: '确认是否已收到该订单对应金额的正规发票?',
  cancelOrderTip: '请确认是否取消订单，一旦取消，已支付款项会退回对应的代理商账户和调整对应期货订单额度！',
  confirmResult: '确认结果：',
  auditResult: '审核结果：',
  confirmRemark: '确认备注：',
  auditRemark: '审核备注：',
  placeholderConfirmRemark: '请填写确认备注',
  agree: '同意',
  reject: '退回',
  creditConfirmWarn: '请确认对方先赊货，销售设备后再付款！！！',
  orderCreateTimeLabel: '下单时间',
  purchaseQuantity: '采购数量',
  actualReceivedAmount: '实收金额',
  receivedGoods: '已收货',
  snMatchSystem: '设备SN码与系统一致',
  bothConfirmRequired: '*必须两者同时确认',
  changeOrderAddress: '变更订单收货地址',

  // 京东仓发货参数配置 JdSendParamConfig
  addLabel: '新增',
  confirmDeleteConfig: '确认删除该条配置吗？',
  jdParamProductLabel: '商品名称：',
  placeholderSelectProduct: '请选择商品',
  paramTypeLabel: '参数类型：',
  placeholderSelectParamType: '请选择参数类型',
  paramValueLabel: '参数值：',
  placeholderSelectParamValue: '请选择参数值',
  mailPayMark: '邮寄付费标记',
  createTimeLabel: '创建时间：',
  typeNameCol: '参数类型',
  conditionCol: '条件',
  typeValueNameCol: '参数值',
  createTimeStrCol: '创建时间',
  createByNameCol: '创建人',
  editJdParamTitle: '修改京东仓发货参数配置',
  addJdParamTitle: '新增京东仓发货参数配置',
  agentLabel: '代理商：',
  dispatchQuantity: '发货数量',
  unitTai: '台',
  placeholderMinNum: '请输入最小值',
  placeholderMaxNum: '请输入最大值',
  deleteSuccess: '删除成功',
  deleteFailed: '删除失败',

  // 区域采购 SecondmentGoods
  regionPurchase: '区域采购',
  deductPay: '抵扣支付',
  fissionAccount: '裂变账户',
  placeholderEnterContent: '请输入内容',
  accountBalance: '账户余额',
  maxDeduct: '最高可抵扣',
  confirmPaymentReceived: '请确认对方收到货款后再点击同意！！！',
  confirmCancelShort: '确认取消吗？',
  applicationNo: '申请单编号',
  applicantCampusId: '申请代理商ID',
  applicantCampusName: '申请代理商名称',
  fissionDeductAmount: '裂变抵扣金额',
  remainingPayAmount: '剩余待支付金额',
  transferNumCol: '调货数量',
  statusCol: '状态',
  receiverCol: '收货人',
  mobileCol: '收货人手机',
  remarkCol: '备注',
  confirmTimeCol: '确认时间',
  confirmByCol: '确认人',
  confirmRemarkCol: '确认备注',
  createTimeCol: '创建时间',
  createByCol: '创建人',
  orderNoLabelColon: '订单编号：',
  placeholderOrderNoShort: '请输入订单编号',
  dispatchRegionAgentColon: '发货区域代理：',
  placeholderSelectDispatchRegion: '请选择发货区域代理',
  statusLabel: '状态',
  placeholderSelectStatus: '请选择状态',
  createTimeLabelShort: '创建时间',
  confirmTimeLabel: '确认时间',
  productNameLabelColon: '商品名称：',
  placeholderProductName: '请输入商品名称',
  isFissionDeduct: '是否裂变抵扣',
  optionNo: '否',
  optionYes: '是',

  // 销售资料 SalesData
  createMaterial: '创建资料',
  materialPreview: '资料预览',
  clickToViewVideo: '点击查看视频',
  pendingPublish: '待发布',
  published: '已发布',
  publish: '发布',
  cancelPublish: '取消发布',
  viewInfo: '查看信息',
  editInfoTitle: '编辑信息',
  fillCreateInfo: '填写创建信息',
  nameLabel: '名称',
  placeholderMaterialName: '请输入资料名称',
  materialSort: '资料排序',
  placeholderSort: '1-98',
  catalogDir: '分类目录',
  uploadMaterial: '上传资料',
  imageMaterial: '图片资料',
  videoMaterial: '视频资料',
  viewImage: '查看图片',
  editImageLabel: '编辑图片',
  replace: '替换',
  uploadImageTip: '建议图片宽度:1080 X 600，点击图片可进行信息提示标记',
  materialInterpret: '资料解读',
  placeholderInterpret: '输入该资料的解读，限制最大字数500字',
  confirmDeleteMark: '确定删除此标记吗？',
  insertText: '插入文字',
  tipTitle: '提示',
  confirmPublishMaterial: '是否发布该资料',
  confirmCancelPublishMaterial: '是否取消发布该资料',
  confirmDeleteMaterial: '是否删除该资料，删除后不可恢复',
  createNow: '立即创建',
  materialNameLabel: '资料名称',
  catalogNameCol: '所属分类',
  createTimeCol: '创建时间',
  updateTimeCol: '最后编辑时间',
  updateByNameCol: '最后编辑人',
  placeholderSelectCatalog: '请选择分类目录',
  pleaseUploadMaterial: '请上传资料',
  pleaseEnterMaterialSort: '请输入资料排序',

  // Compliance 合规
  batchViolationDisable: '批量违规禁用',
  studentName: '学员姓名',
  studentAccount: '学员账号',
  serviceCenterId: '服务中心ID',
  serviceCenterName: '服务中心名称',
  restore: '恢复',
  restoreUse: '恢复使用',
  restoreReason: '恢复原因',
  violationDisable: '违规禁用',
  disableReason: '禁用原因',
  pleaseEnterReason: '请输入原因',
  nameOrPhone: '姓名/手机号',
  placeholderNameOrPhone: '请输入姓名/手机号',
  employeeLearningAccountLabel: '员工学习账号',
  placeholderEmployeeLearningAccount: '请输入员工学习账号',
  dealerIdLabel: '经销商ID',
  placeholderDealerId: '请选择经销商ID',
  learningAccountStatus: '学习账号状态:',
  placeholderAccountStatus: '请选择账号状态',
  statusNormal: '正常',
  statusDisabled: '禁用',
  statusExpired: '到期',
  statusViolationDisabled: '违规禁用',
  multiSelect: '多选',
  nameCol: '姓名',
  phoneCol: '手机号',
  accountCol: '账号',
  dealerNameCol: '经销商名称',
  employeeLearningAccountStatusCol: '员工学习账号状态',
  disableReasonColon: '禁用原因：',
  selectedAccountList: '已选择账号列表',
  tipTotalCount: '共{count}个',
  studentInfoLabel: '学员信息',
  placeholderStudentInfo: '学员姓/学员账号',
  serviceCenterLabel: '服务中心',
  placeholderServiceCenter: '请选择经销商ID/经销商名称',
  accountStatusLabel: '账号状态:',
  userStatusNameCol: '账户状态',
  machineAccountCol: '学习机账户',
  statusPause: '暂停',

  // Compliance HardDevices 硬件设备
  batchLock: '批量锁定',
  selectedDeviceList: '已选择设备列表',
  machineModel: '学习机型号',
  machineSnCode: '学习机SN码',
  placeholderMachineSnCode: '学习机SN码',
  deviceStatusLabel: '设备状态:',
  deviceStatusPlaceholder: '设备状态',
  statusLocked: '已锁定',
  machineModelCol: '学习机型号',
  machineSnCodeCol: '学习机SN码',
  lockStatusNameCol: '设备状态',
  lock: '锁定',
  unlock: '解锁',
  deviceLock: '设备锁定',
  deviceUnlock: '设备解锁',
  lockReason: '锁定原因',
  unlockReason: '解锁原因',

  // 总部发货 HeadOfficeShipment
  cloudWarehouseDispatch: '云仓发货',
  transferToSuperior: '转上级发货',
  printDispatchOrder: '打印发货单',
  adjustDispatchMethod: '调整发货方式',
  dispatchOrderConfirm: '发货单确认',
  pleaseSelectDispatchOrder: '请选择发货单',
  createDispatchOrderSuccess: '生成发货单成功！',
  createDispatchOrderFailed: '生成发货单失败！',
  confirmTransferTo: '确认将此订单转移至 {name} 么？',
  confirmTransferToBefore: '确认将此订单转移至 ',
  confirmTransferToAfter: ' 么？',
  transferLabel: '转移',
  transferGoods: '调货',
  orderNoColon: '订单编号:',
  placeholderOrderNoInput: '请输入订单编号',
  orderStatusLabel: '订单状态:',
  placeholderOrderStatus: '请选择订单状态',
  createTimeColon: '创建时间:',
  receiverInfoLabel: '收货人信息:',
  placeholderReceiverInfo: '请输入收货人信息',
  tmallOrderNoLabel: '天猫订单编号:',
  placeholderTmallOrderNo: '请输入天猫订单编号',
  placeholderEclpSoNo: '请输入云仓出库单号',
  isAutoOrderLabel: '是否自动订单:',
  placeholderIsAutoOrder: '请选择是否自动订单',
  statusConfirmed: '已确认',
  statusDelivering: '发货中',
  statusDelivered: '已发货',
  statusPartialDeliver: '部分发货',
  statusReceiveConfirm: '收货确认',
  statusRejectPending: '拒收待发出',
  purchaseOrTransferNo: '采购单号/调货单号:',
  provinceCity: '所在省市:',
  deliveryAddress: '收货地址:',
  agentIdLabel: '代理商ID:',
  receiverPhone: '收货人电话:',
  creditOrderNoCol: '赊货订单编号',
  payStatusLabel: '收款状态',
  placeholderPayStatus: '请选择付款状态',
  orderStatusLabelCr: '订单状态',
  placeholderOrderStatusCr: '请选择订单状态',
  payStatusCol: '收款状态',
  selectConfirmResult: '请选择确认结果',
  purchaseNoLabel: '采购单号',
  placeholderPurchaseNo: '请输入采购单号',
  creatorLabel: '创建人',
  placeholderCreator: '请选择人员',
  orderTimeLabel: '下单时间',
  lastPayTimeLabel: '最后支付时间',
  buyNumLabel: '采购量',
  orderAmountLabel: '采购金额',
  receivedAmountLabel: '实付金额',
  submitterLabel: '提交人',
  placeholderSubmitter: '请选择人员',
  statusLabelPurch: '订单状态',
  placeholderStatusPurch: '请选择订单状态',
  orderTypeLabel: '订单类型',
  placeholderOrderType: '请选择订单类型',
  submitTimeLabel: '提交时间',
  receiverMobileLabel: '收货人信息',
  placeholderReceiverMobile: '请输入收货人姓名或手机查询',
  dispatchTypesLabel: '收货方式',
  placeholderDispatchTypes: '多选框',
  regionInvoiceStatusLabel: '发票确认',
  placeholderInvoiceType: '请选择开票类型',
  discountAmountCol: '优惠金额',
  freightAmountCol: '预收运费',
  receiveNumCol: '发货数量',
  dispatchTypeNameCol: '发货方式',
  lastPayTimeCol: '最后支付时间',
  orderTimeCol: '下单时间',
  submitterNameCol: '提交人',
  orderTypeNameCol: '订单类型',
  submitTimeCol: '提交时间',
  invoiceConfirmCol: '发票确认',
  regionConfirmTimeCol: '确认时间',
  invoiceStatusInvoiced: '已开票',
  invoiceStatusNotInvoiced: '未开票',

  // AgentRenewalRewardShare 续费奖励分享
  sendTimeLabel: '发货时间',
  settlementYearMonth: '结算年月',
  placeholderMonth: '请选择月份',
  introduceCustomName: '转介绍客户名称',
  purchaseUnitPriceCol: '采购单价',
  purchaseTotalPriceCol: '采购总金额',
  deliveryTimeCol: '发货时间',
  yearAndMonthCol: '结算年月',
  shareCampusIdCol: '分担代理商ID',
  shareMoneyCol: '分担金额',

  // studyMachine 学习机/设备管理（snCodeLabel / placeholderSnCode 与 CrossRegionalReview 等同键共用，见上文）
  productTypeLabel: '商品类型',
  placeholderProductType: '请选择商品类型',
  accountStatusLabelEq: '账户状态：',
  placeholderAccountStatusEq: '请选择账户状态',
  activateDateLabel: '账户激活日期：',
  dispatchDateLabel: '发货日期：',
  expressCompanyLabel: '快递公司：',
  placeholderExpressCompany: '请选择快递公司',
  expressNoLabel: '快递单号：',
  placeholderExpressNo: '请选择快递单号',
  logisticsStatusLabel: '物流状态：',
  placeholderLogisticsStatus: '请选择物流状态',
  stockStatusLabel: '库存状态：',
  placeholderStockStatus: '请选择库存状态',
  statusInactive: '未激活',
  statusActive: '已激活',
  statusFrozen: '冻结',
  statusSubscribed: '已订阅',
  stockNotOut: '未出库',
  stockOut: '已出库',
  logisticsDetail: '物流详情',
  studyMachineRemark: '学习机备注',
  companyNameLabel: '公司名称:',
  selectCompany: '请选择公司',
  remarkLabelShort: '备注：',
  placeholderRemarkContent: '请输入内容',
  snCodeCol: '设备SN码',
  machineNameCol: '商品名称',
  campusIdCol: '代理商ID',
  campusNameCol: '代理商名称',
  statusNameCol: '账户状态',
  deviceStatusCol: '设备状态',
  stockStatusCol: '库存状态',
  firstUseTimeCol: '设备激活时间',
  activateTimeCol: '账户激活时间',
  dispatchTimeCol: '发货日期',
  expressNameCol: '快递公司',
  expressNoCol: '快递单号',
  expressStatusNameCol: '物流状态',
  purchaseNoCol: '采购单号',
  contentCol: '备注',
  orderedQtyColon: '订购数量:',
  shippedQtyColon: '已发数量:',
  expressCompanyColon: '快递公司:',
  expressNoColon: '快递单号:',
  placeholderFillExpressNo: '请填写快递单号',
  transferAreaLeft: '待选区',
  transferAreaRight: '已选区',
  jdWarehouseReminderTitle: '京东云仓提醒',
  jdWarehouseReminderContent: '所选设备：{snCodes} 显示还在京东仓，可能导致实际发货设备与sn码不一致，是否继续确认调码？',
  continue: '继续',
  ruleSelectProduct: '请选择商品',
  ruleSelectParamType: '请选择参数类型',
  ruleSelectParamValue: '请选择参数值',
  ruleFillActivityForm: '请填写活动形式',
  saveSuccess: '保存成功',
  shipWarehouseLabel: '发货仓库：',
  placeholderSelectShipWarehouse: '请选择发货仓库',
  eclsSoNoLabel: '京东仓出库编号：',
  agentWarehouseLabel: '代理商收货仓：',
  placeholderCampusAddress: '请输入校区地址',
  productDetail: '商品详情',
  relatedOrders: '关联订单',
  orderWaitSendNum: '订单待发货数量',
  orderProductCol: '订单商品',
  shipDateCol: '发货日期',
  shipNumCol: '发货数量',
  placeholderShipStatus: '发货状态',
  placeholderRemark200Chars: '请输入备注，200字以内',
  ruleSelectShipWarehouse: '请选择发货仓库',
  ruleEnterReceiverPhone: '请输入收货人电话',
  ruleSelectProvinceCity: '请选择省市区',
  ruleSelectShipStatus: '请选择发货状态',
  ruleEnterShipAddress: '请输入发货地址',
  placeholderSnOrPurchaseNo: '请输入SN码或采购单号',
  equipmentListExport: '设备管理列表导出',
  procureAgentBalance: '采购代理商余额',
  applyNoLabel: '申请编号：',
  statusLabel: '状态：',
  pendingAudit: '待审核',
  applyAgentLabel: '申请代理商：',
  auditRegionAgentLabel: '审核区代：',
  teacherNameLabel: '教师姓名：',
  placeholderTeacherName: '请输入教师姓名',
  teacherPhoneLabel: '教师手机号：',
  placeholderTeacherPhone: '请输入教师手机号',
  childNameLabel: '子女姓名：',
  placeholderChildName: '请输入子女姓名',
  teacherCertNoLabel: '教师证编号：',
  placeholderTeacherCertNo: '请输入教师证编号',
  creatorLabelShort: '创建人',
  applyRemarkLabel: '申请备注：',
  placeholderApplyRemark: '请填写申请备注',
  createTimeLabelShort: '创建时间：',
  teacherCertMaterialsLabel: '教师证及教师身份证明材料：',
  commitmentLabel: '承诺书',
  ruleUploadImage: '请上传图片',

  // ReportConfirm 跨区报备复核
  reportAgentLabel: '报备地代理商',
  placeholderReportAgent: '请选择报备地代理商',
  reportStatusLabel: '状态：',
  placeholderReportStatus: '请选择状态',
  reportTimeLabel: '报备时间',
  crossTypeLabel: '跨区域类型',
  placeholderCrossType: '请选择跨区域类型',
  reviewResultLabel: '复核结果',
  placeholderReviewResult: '请选择复核结果',
  reviewCompliant: '合规',
  reviewNonCompliant: '不合规',
  reviewTimeLabel: '复核时间',
  snActiveStatusLabel: '软件激活状态',
  placeholderSnActiveStatus: '请选择软件激活状态',
  reportAddressLabel: '报备激活地',
  placeholderReportAddress: '请选择报备激活地',
  finishTimeLabel: '完成时间',
  createTimeLabel: '创建时间',
  leaderAgentLabel: '所属地代理商',
  placeholderLeaderAgent: '请选择所属地代理商',
  isAuditLabel: '是否需复核',
  placeholderIsAudit: '请选择是否需复核',
  optionAll: '全部',
  optionYes: '是',
  reviewDialogTitle: '复核',
  snCodeColon: 'SN码：',
  ownerDealerColon: '所属经销商：',
  reportAddressColon: '报备激活地：',
  dealerAddressColon: '经销商所在地：',
  reportAgentColon: '报备地代理商：',
  leaderAgentColon: '上级代理商：',
  snActiveStatusColon: '软件激活状态：',
  statusColon: '状态：',
  crossTypeColon: '跨区类型：',
  reportByColon: '报备人：',
  reportTimeColon: '报备时间：',
  lastUpdateColon: '末次修改时间：',
  paymentVoucher: '支付凭证：',
  reportReasonColon: '报备原因：',
  operTimeCol: '操作时间',
  operByCol: '操作人',
  reportStatusCol: '报备状态',
  reviewResultCol: '复核结果',
  reviewResultStrong: '复核结果:',
  reviewRemarkStrong: '复核备注:',
  submitBtn: '提 交',
  leaderAgentIdCol: '所属地代理商ID',
  leaderAgentNameCol: '代理商名称',
  reportAgentAddressCol: '报备激活地',
  reportAgentIdCol: '报备地代理商ID',
  reportAgentNameCol: '报备地代理商名称',
  crossTypeNameCol: '跨区域类型',
  reportStatusNameCol: '状态',
  snActiveStatusNameCol: '软件激活状态',
  snActiveTimeCol: '软件激活时间',
  reviewResultNameCol: '复核结果',
  reportReasonCol: '报备原因',
  reportByNameCol: '报备人',
  reportTimeCol: '报备时间',
  ownerCampusIdCol: '所属经销商ID',
  ownerCampusNameCol: '经销商名称',
  ownerCampusAddressCol: '经销商所在地',
  createTimeColReport: '创建时间',
  updateTimeCol: '末次修改时间',
  reviewTimeCol: '复核时间',
  reviewByNameCol: '复核人',
  finishTimeCol: '完成时间',
  finishByNameCol: '完成人',
  pleaseFillReviewResult: '请填写复核结果',
  pleaseFillReviewRemark: '请填写复核备注',
  pleaseFillCancelDuration: '请填写取消时长',
  cancelDurationMonthsRule: '取消时长需为 1~12 的正整数（月）',
  cancelCrossRegionQuotaLabel: '取消经销商跨区激活额度:',
  cancelDurationMonthsLabel: '取消时长(月):',
  placeholderReviewRemarkInput: '请输入内容',
  pdfFileAlt: 'PDF 文件',
  downloadFileTitle: '下载文件',
  previewFileTitle: '预览文件',
  pdfUrlMissing: 'PDF 文件地址不存在',
  reviewBtn: '复核',
  snCodeShort: 'SN码',

  // ChildrenDevice 子女设备
  childApplyNoLabel: '申请编号：',
  placeholderApplyNo: '请输入申请编号',
  auditRegionAgentLabel: '审核区代',
  teacherNameLabel: '教师姓名：',
  placeholderTeacherName: '请输入教师姓名',
  teacherPhoneLabel: '教师手机：',
  placeholderTeacherPhone: '请输入教师手机',
  teacherCertNoLabel: '教师证编号：',
  placeholderTeacherCertNo: '请输入教师证编号',
  createTimeLabelColon: '创建时间：',
  auditTimeLabelColon: '审核时间：',
  statusLabelChild: '状态：',
  placeholderStatusChild: '请选择状态',
  statusPendingAudit: '待审核',
  statusAuditPass: '审核通过',
  statusAuditReject: '审核退回',
  deviceSnLabel: '设备SN：',
  placeholderSnCodeSearch: '根据设备SN进行搜索',
  childAccountNoCol: '申请编号',
  childNameCol: '子女姓名',
  teacherNameCol: '教师姓名',
  teacherPhoneCol: '教师手机',
  teacherCertificateNoCol: '教师证编号',
  auditRemarkCol: '审核备注',
  auditTimeColChild: '审核时间',
  auditByNameCol: '审核人',
  regionCampusIdColChild: '审核区代ID',
  regionCampusNameColChild: '审核区代名称',

  // DoubleOrder 双单
  isVoucherIssuedLabel: '是否已发提货券',
  placeholderIsVoucherIssued: '请选择是否已发提货券',
  voucherIssuedCol: '是否已发放提货券',
  relatedAgentLabel: '关联代理商',
  placeholderRelatedAgent: '请选择关联代理商',
  relatedAgentIdCol: '关联代理商ID',
  relatedAgentNameCol: '关联代理商名称',
  placeholderDispatchMethod: '请选择发货方式',
  confirmTimeCol: '确认时间',

  // TakeDelivery 仓内提货
  newLading: '新建提货单',
  ladingNoLabel: '提货单号',
  placeholderLadingNo: '请输入提货单号',
  warehouseLabel: '所属仓库',
  placeholderWarehouse: '请选择仓库',
  sendStatusLabel: '发货状态',
  placeholderSendStatus: '请选择发货状态',
  warehouseOrderNoLabel: '云仓出库单号',
  placeholderWarehouseOrderNo: '请输入云仓单号',
  cancelShipment: '取消发货',
  confirmCancelLading: '确认取消发货单？',
  prepayFreight: '预付运费',
  ladingNoCol: '提货单号',
  warehouseNameCol: '所属仓库',
  warehouseOrderNoCol: '云仓出库单号',
  sendStatusNameCol: '发货状态',
  receivedAmountColLading: '预付运费',
  extractNumCol: '提货数量',

  // SquirrelJuvenile 少年松鼠
  searchUserLabel: '搜索用户',
  placeholderSearchUser: '请输入用户',
  recommendStudentNameCol: '推荐学员姓名',
  studentPhoneCol: '手机号',
  recommendTimeCol: '推荐时间',
  auditStatusCol: '审核状态',
  auditPassTimeCol: '审核通过时间',
  voteNoCol: '投票编号',
  voteNumCol: '当前票数',
  rankCol: '当前排名',
  tabPendingAudit: '待审核',
  tabAuditPass: '审核通过',
  confirmWriteOffGift: '确认核销礼包吗？',
  tipTitle: '提示',
  updateByNameColSq: '操作人',
  campusIdColSq: '所属经销商ID',
  campusNameColSq: '所属经销商名称',
  writeOffSuccess: '核销成功',
  // checkSquirrelJuvenile 报名审核
  signupAuditTitle: '报名审核',
  playerDetailTitle: '选手详情',
  voteNoLabel: '编号',
  rankLabel: '排名',
  voteNumLabel: '票数',
  distancePrevLabel: '距上一名',
  storyWithSquirrelTitle: '我和松鼠的故事',
  auditPassBtn: '审核通过',
  rejectApplyBtn: '驳回申请',
  auditDialogTitle: '审核',
  confirmAuditPass: '确认审核通过',
  rejectReasonTitle: '驳回原因',
  rejectReasonLabel: '请填写驳回原因：',
  placeholderRejectReason: '请填写驳回原因',
  confirmRejectBtn: '确定驳回',
  ruleRejectReasonRequired: '请填写驳回原因',
  auditPassSuccess: '审核通过',
  rejectSuccess: '驳回成功',
  operationFailed: '操作失败',

  // LoanAndReturn 仓间借还货
  newTransfer: '新建调拨单',
  transferOrderNoLabel: '调拨单号',
  placeholderTransferOrderNo: '请输入调拨单号',
  outCampusLabel: '调出代理商',
  placeholderOutCampus: '请输入代理商',
  inCampusLabel: '调入代理商',
  placeholderInCampus: '请输入代理商',
  docStatusLabel: '单据状态',
  placeholderDocStatus: '请选择单据状态',
  relationTransferOrderLabel: '关联调拨单',
  placeholderRelationTransfer: '请输入关联调拨单',
  outWarehouseLabel: '调出仓库',
  inWarehouseLabel: '调入仓库',
  placeholderWarehouseInput: '请输入仓库',
  warehouseTransferNoLabel: '云仓调拨单号',
  placeholderWarehouseTransferNo: '请输入云仓单号',
  docStatusPending: '待审核',
  docStatusRejected: '未通过',
  docStatusCancelled: '已取消',
  docStatusApproved: '已审核',
  sendStatusNew: '新建',
  sendStatusInitial: '初始',
  sendStatusComplete: '完成',
  sendStatusCancelSuccess: '取消成功',
  sendStatusProduceFail: '生产失败',
  confirmCancelShort: '确认取消吗？',
  transferOrderNoCol: '调拨单号',
  transferNumCol: '调拨数量',
  transferredNumCol: '已调拨数量',
  outCampusIdCol: '调出代理商ID',
  outCampusNameCol: '调出代理商名称',
  inCampusIdCol: '调入代理商ID',
  inCampusNameCol: '调入代理商名称',
  outWarehouseNameCol: '调出仓库',
  inWarehouseNameCol: '调入仓库',
  relationOrderNoCol: '关联调拨单',
  warehouseTransferNoCol: '云仓调拨单号',
  orderStatusNameCol: '单据状态',

  // CloudProduct 云仓商品库存
  totalInventoryCol: '总库存',
  availableInventoryCol: '可用库存',
  totalInventoryLabel: '总库存',
  availableInventoryLabel: '可用库存',
  partnerWarehouseCol: '合作云仓',

  // Partner CustomerOrderDetails
  placeholderIntroduceCustomerSearch: '请输入客户ID或名称关键字',
  orderTimeRangeLabel: '下单时间',
  placeholderOrderTimeRange: '请选择下单时间范围',
  deliveryTimeRangeLabel: '发货时间',
  placeholderDeliveryTimeRange: '请选择发货时间范围',
  introduceCustomerIdCol: '转介绍客户ID',
  introduceCustomerNameCol: '转介绍客户名称',
  purchaseNoLabel: '采购单号',
  partnerCustomerOrderTypeNameCol: '采购类型',
  dispatchTypeNameCol: '发货方式',
  partnerCustomerPayStatusCol: '支付状态',
  statusCol: '订单状态',
  productNameCol: '商品名称',
  purchaseQuantity: '采购数量',
  receiveNumCol: '发货数量',
  purchaseUnitPriceCol: '采购单价',
  orderAmount: '采购总金额',
  cashAmountCol: '纯现金支付金额',
  orderTimeCol: '下单时间',
  lastDispatchTimeCol: '发货时间',
  partnerCampusIdCol: '战略/事业合伙人ID',
  partnerCampusNameCol: '战略/事业合伙人名称',

  // PrototypeManagement 样机管理
  machineAccountLabel: '学习机账户：',
  placeholderMachineAccount: '请输入学习机账户',
  searchStudentLabel: '搜索学员：',
  placeholderSearchStudent: '请输入学院账号、学员姓名',
  accountActiveDateLabel: '账户激活日期：',
  placeholderAccountActiveDateRange: '请选择账户激活日期范围',
  placeholderSnCode: '请输入SN码',
  accountStatusLabelPrototype: '账户状态：',
  placeholderAccountStatus: '请选择账户状态',
  statusActivated: '已激活',
  statusFrozen: '冻结',
  statusSubscribed: '已订阅',
  machineAccountCol: '学习机账户',
  prototypeProductNameCol: '商品名称',
  prototypeStatusCol: '状态',
  accountActiveDateCol: '账户激活时间',
  certificateAreaCol: '当前认证区域',
  accountUserCol: '学生账号',
  userNameCol: '学生姓名',
  periodValidityCol: '账户有效期',
  markPrototype: '标记样机',
  prototypeAccountRenew: '样机账户续期',
  accountPhoneRebind: '账户手机换绑',
  unmarkPrototype: '取消样机标记',
  productModelLabel: '商品型号：',
  deviceSnLabel: '设备SN码：',
  placeholderDeviceSn: '请输入设备SN码',
  prototypeTypeLabel: '样机类型：',
  placeholderPrototypeType: '请选择样机类型',
  dispatchedPrototypeCnt: '已发货样机数：',
  signedPrototypeCnt: '商品标记样机数：',
  markablePrototypeCnt: '可标记样机数：',
  traineeAccountCol: '学员账号',
  studentNameColPrototype: '学生姓名',
  schoolIdCol: '校区ID',
  schoolNameCol: '校区名称',
  notePrototypeLabel: '注：',
  notePrototype1: '1、学习机一旦标记为样机，将不可修改；',
  notePrototype2: '2、样机不可用于销售，仅作体验和展示用途；',
  notePrototype3: '3、每台样机只能绑定一个学习账号，已绑定多个学习账号的设备标记为样机，必须选择保留的账号，其他账号将与学习机解绑；',
  prototypeAccountRenewTitle: '样机账户续期申请',
  prototypeSnLabel: '样机SN码：',
  learningMachineAccountLabel: '学习机账户：',
  currentCertAreaLabel: '当前认证区域：',
  accountActiveTimeLabel: '账户激活时间：',
  accountValidityLabel: '账户有效期：',
  renewBtn: '续期',
  accountPhoneRebindTitle: '账户手机换绑',
  accountNoLabel: '学习机账户编号：',
  agentIdLabel: '代理商ID：',
  agentNameLabel: '代理商名称：',
  originalPhoneLabel: '原手机号：',
  newPhoneLabel: '新手机号：',
  verifyCodeLabel: '验证码：',
  placeholderOriginalPhone: '请填写原手机号',
  placeholderNewPhone: '请填写新手机号',
  placeholderVerifyCode: '请输入验证码',
  sendVerifyCode: '发送验证码',
  resendVerifyCode: '重新发送',
  resendAfterSeconds: '秒后重新发送',
  nextStep: '下一步',
  rulePhoneRequired: '请输入手机号',
  ruleVerifyCodeRequired: '请输入验证码',
  ruleDeviceSnRequired: '请输入设备SN码',
  pleaseVerifySnFirst: '请先验证设备SN码',
  pleaseSelectPrototypeType: '请选择样机类型',
  pleaseSelectTrainee: '请选择学员',
  confirmMarkPrototypeTip: '学习机一旦标记为样机，将不可修改',
  markSuccess: '标记成功',
  renewFail: '续费失败',
  renewSuccess: '续费成功',
  pleaseEnterNewPhone: '请输入新手机号',
  verifyCodeSent: '验证码发送成功',
  rebindSuccess: '换绑成功',
  rebindFail: '换绑失败',
  submitFail: '提交失败',

  // CatalogManagement 目录管理
  addCatalogBtn: '新增目录',
  catalogSortCol: '目录排序',
  catalogNameLabelCol: '目录名称',
  materialCountCol: '资料数量',
  addCatalogTitle: '新增目录信息',
  editCatalogTitle: '编辑目录信息',

  // AutomaticOrderConfiguration 自动下单配置
  addProductRatioBtn: '新增商品配比',
  autoOrderProductRatioMaintain: '自动下单商品配比维护',
  autoOrderRatioTip: '*请务必准确维护各型号配比，自动下单将根据此配比分配下单金额！所有型号配比合计必须等于100%。',
  ratioLabel: '配比',
  totalRatioLabel: '合计',
  updateLogLabel: '更新记录：',
  ratioValueError: '请正确填写配比值：1到100的整数，且配比合计等于100%',
  placeholderRatio: '请输入配比',
  campusIdColShort: '代理商id',
  modelNameCol: '商品型号',
  activeStatusCol: '商品状态',
  productRatioCol: '商品配比（合计=100）',
  lastUpdateTimeCol: '末次修改时间',
  lastUpdateByCol: '末次修改人',

  // Partner Equity 战略/事业合伙人权益
  partnerTypeCol: '战略/事业合伙人类型',
  investmentAmountCol: '应投资总金额',
  initialPaymentCol: '首付款金额',
  additionalPaymentCol: '转介绍补投资款金额',
  investmentRateCol: '转介绍投补资款折算比例',
  totalPaymentCol: '合计投资金额',
  equityPeriodCol: '权益周期',
  paymentDeadlineCol: '完款期限',
  equityStatusCol: '权益状态',
  withdrawalRateCol: '货款提现比例',
  commissionRateCol: '首笔款佣金奖励比例',
  renewalRateCol: '续费佣金奖励比例',

  // SubscriptionCardManagement Experience 体验额度
  experienceDealerIdCol: '经销商ID',
  experienceDealerNameCol: '经销商名称',
  experienceCityCol: '所属区域',
  experienceLimitCol: '体验额度',
  experienceUsedLimitCol: '已使用额度',
  softActiveNumCol: '软件激活数量',
  grantExperienceLimit: '发放体验额度',
  experienceMonthLimitLabel: '本月可发放额度：',
  grantExperienceDialogTitle: '发放体验额度',
  experienceDealerIdLabel: '经销商ID：',
  experienceDealerNameLabel: '经销商名称：',
  experienceRemainLimitLabel: '本月剩余额度：',
  experienceGrantAmountLabel: '发放额度数量：',
  placeholderGrantAmount: '请输入发放额度数量',
  experienceOverDialogTitle: '体验额度已用完',
  experienceOverMessage: '您本月的可发放体验额度已用完',
  msgGrantAmountRequired: '请输入发放额度数量',
  msgGrantAmountMin: '发放额度不能小于1',
  msgGrantAmountMax: '发放额度不能超过本月可发放额度{count}',
  msgGrantSuccess: '发放成功',
  msgGrantAmountEmpty: '发放额度不能为空',
  exportExperienceName: '体验管理',

  // Creditorders 赊货订单
  receiptConfirmTitle: '收货确认',
  receivedRadio: '已收货',
  deviceSnMatchRadio: '设备SN码与系统一致',
  bothConfirmRequired: '*必须两者同时确认',
  confirmCancelQuestion: '确认取消吗？',
  payConfirmDialogTitle: '提示',
  payDeductTip: '本次支付将扣除：',
  voucherAccountPayLabel: '裂变奖金账户：',
  cashAccountPayLabel: '现金账户：',
  goldAccountPayLabel: '金账户：',
  deliveryVoucherPayLabel: '提货券帐户：',
  yuan: '元',
  provinceNoCreditMsg: '省代无法赊货，请使用线上订单向省代订货！',
  onlyDealerCreditMsg: '只有经销商可以申请赊货，您是代理商，请使用线上订单订货！',
  creditQueryFailed: '查询失败',
  creditSubmitFailed: '提交失败',
  creditSubmitSuccess: '提交成功',
  pleaseConfirmReceived: '请确认是否已确认收货',
  pleaseConfirmDeviceSn: '请确认设备SN与系统是否一致',
  creditConfirmSuccess: '确认成功',
  creditConfirmFailed: '确认失败',
  creditCancelSuccess: '取消成功',
  creditCancelFailed: '取消失败',
  // 运费弹窗 LadingFreightFeesDialog
  freightPlanTitle: '运费方案：',
  freightPlan1: '方案一: 运费到付:',
  freightPlan1Desc: '（收货后支付给配送员，实际金额可能会有20%的浮动，以实际为准）',
  freightPlan2: '方案二: 运费预付:',
  freightPlan2Desc: '（原价{original}元，与订货款一起支付，出现争议由总部负责）',
  freightPlan2DescShort: '（原价{original}元，与订货款一起支付，出现争议由总部负责）',
  freightTipsTitle: '本订单采购数量不足10台，按公司快递规则是: 到付;为了让大家享受邮费打折的优惠，现提供预付到付运费的服务，请注意:',
  freightRule1: '1、到付运费折扣以公司与京东仓签订的折扣为准，目前折扣: 6.5折，以后如有变化，会及时通知;',
  freightRule2: '2、预收到付运费自愿选择，如果放弃预付运费所享受的折扣，须在签收时支付到付运费给快递公司，具体支付金额和方式以快递公司为准;',
  freightRule3: '3、预收到付运费收取后，如果此订单与其他订单合并配送，满足免运费条件(数量大于等于10台)，完成后，自动退还预收运费;',
  chargeItemCol: '收费项目',
  unitPriceCol: '单价',
  qtyCol: '数量',
  amountCol: '金额',
  discountCol: '折扣',
  discountedAmountCol: '优惠后的金额',
  payFreightCollect: '支付(运费到付)',
  payFreightPrepay: '支付(运费预付)',
  dispatchSuccess: '发货成功',
  dispatchFailed: '发货失败',
  operateTooFrequent: '请勿操作过于频繁',

  creditOrderRightsModifyWarn: '此订单使用了权益，无法修改，你可以先取消订单后再重新下单。',
  creditPayFailed: '付款失败',
  paySuccessTitle: '支付成功',
  payFailTitle: '支付失败',
  pleaseSelectConfirmResult: '请选择确认结果',
  deductPaySuccess: '支付成功',

  // CreditordersCreation 赊货单创建/详情
  creditOrderNoLabel: '申请单编号：',
  creditApplyAgentLabel: '申请代理商：',
  createByLabel: '创建人：',
  receiveRegionAgentLabel: '收货区代：',
  agentWarehouseLabel: '代理商收货仓：',
  receiverLabel: '收货人：',
  receiverPhoneLabel: '收货人电话：',
  provincesLabel: '省市区：',
  addressLabel: '收货地址：',
  remarkLabelShort: '备注：',
  placeholderCampusAddress: '请输入校区地址',
  placeholderRemark200: '请输入备注，200字以内',
  ruleOrderTypeRequired: '请输入采购类型',
  ruleReceiverRequired: '请输入收货人',
  ruleMobileRequired: '手机号不能为空',
  ruleProvincesRequired: '请选择省市区',
  ruleDispatchTypeRequired: '请选择方式',
  ruleAddressRequired: '请输入收货地址',
  ruleWarehouseRequired: '请选择代理商收货仓',
  addGoodsBtn: '+选择添加商品',
  goodsDetailTitle: '商品详情',
  addDiscountBtn: '+选择优惠',
  selectedDiscountDesc: '已选{selected}张/ {total}张可用',
  availableDiscountDesc: '{total}张可用',
  discountInfoTitle: '优惠信息',
  logisticsDetailTitle: '物流详情',
  paymentDetailTitle: '支付详情',
  auditDetailTitle: '审核详情',
  priorityPurchaseRightText: '享受"限量机型优先采购"权益',
  discountRightText: '享受"进货价折扣"权益：',
  originalTotalLabel: '原价合计：',
  discountAmountLabel: '优惠金额：￥',
  purchaseAmountLabel: '采购金额：',
  selectDiscountTitle: '选择优惠',
  addGoodsTitle: '添加商品',
  stockRemindTitle: '商品库存状态提醒',
  stockRemindContentBefore: '您选购的商品库存状态为: ',
  stockRemindContentAfter: '，到货时间可能较长，您可以返回，重新选择其他商品，或者继续下单，耐心等待发货;',
  continueOrderBtn: '继续下单',
  reselectGoodsBtn: '重新选择商品',
  confirmDeleteQuestion: '确认删除吗？',
  creditCreationProductNameCol: '商品名称',
  creditCreationUnitPriceCol: '单价',
  creditCreationQuantityCol: '数量',
  creditCreationAmountCol: '金额',
  paySerialNoCol: '支付流水号',
  payMethodCol: '支付方式',
  payTimeCol: '支付时间',
  payAmountCol: '支付金额',
  operatorCol: '操作人',
  dispatchDateCol: '发货日期',
  expressCompanyCol: '快递公司',
  expressNoCol: '快递单号',
  logisticsStatusCol: '物流状态',
  dispatchNumCol: '发货数量',
  auditTimeCol: '审核时间',
  auditorCol: '审核人',
  auditorCampusIdCol: '审核人所属代理商ID',
  auditorCampusNameCol: '审核人所属代理商名称',
  auditResultCol: '审核结果',
  auditRemarkCol: '审核备注',
  rightNameCol: '权益名称',
  applicableGoodsCol: '适用商品',
  expiryTimeCol: '到期时间',
  rightCodeCol: '权益编码',
  deleteSuccessMsg: '删除成功！',
  pleaseSelectGoodsFirst: '请先选择商品',
  saveSuccess: '保存成功',
  saveFailed: '保存失败',
  msgCorrectMobileRequired: '请输入正确手机号',
  msgDetailedAddressRequired: '请输入详细收货地址，例如x x x省份xxx市xxx区xxx街道xxx号',
  msgAddProductQuantity: '请添加商品数量',
  msgProductQuantityRequired: '商品的数量需要大于0',

  // DoubleOrder 双重订单
  sendVoucherDialogTitle: '发提货券',
  sendVoucherConfirmContent: '一旦提前发放提货券，该双重订单将不可进行任何修改，是否确认发放提货券？',
  invoiceConfirmDialogTitle: '发票确认',
  invoiceConfirmContent: '确认是否已收到该订单对应金额的正规发票?',
  cancelOrderConfirmContent: '请确认是否取消订单，一旦取消，已支付款项会退回对应的代理商账户和调整对应期货订单额度！',
  changeAddressTitle: '变更订单收货地址',
  placeholderReceiver: '收货人',
  placeholderReceiverPhone: '收货人电话',
  placeholderSelectAgentWarehouse: '请选择代理商收货仓',
  placeholderAddress: '请选择收货地址',
  ruleReceiverFill: '请填写收货人',
  ruleMobileValid: '请填写有效的手机号',
  ruleWarehouseRequiredDouble: '请选择代理商收货仓库',
  ruleAddressFill: '请填写收货地址',
  voucherIssuedCannotCancel: '该订单已返提货券，不可进行取消',
  distributeVoucherWarning: '该双重订单请发货后自动返还提货券，或者钉钉申请取消订单，不可提前发放提货券！',
  distributeSuccess: '发放成功',
  promoteAccountPayLabel: '推广费账户：',
  placeholderEnterReceiverPhone: '请输入收货人电话',
  placeholderFillReceiver: '请填写收货人',
  placeholderSelectProvinces: '请选择省市区',
  selectWarehouseFirst: '请选择代理商收货仓',
  selectAddressFirst: '请选择收货地址',
  modifySuccess: '修改成功',
  modifyFailed: '修改失败',
  receivedAmount30PercentTip: '实收金额必须>=采购金额的30%，才能提交至总部备料生产',

  // PurchaseCreation 采购单创建
  purchaseOrderNoLabel: '采购单号：',
  purchaseUnitLabel: '采购单位：',
  purchaseTypeLabel: '采购类型：',
  placeholderSelectPurchaseType: '请选择采购类型',
  dispatchTypeLabel: '发货方式：',
  placeholderSelectDispatchType: '请选择发货方式',
  dispatchRegionAgentLabel: '发货区域代理：',
  freightDetailTitle: '预收运费详情',
  saveAndPayBtn: '保存并支付',
  chargeItemCol: '收费项目',
  freightUnitPriceCol: '单价',
  freightQuantityCol: '数量',
  freightDetailAmountCol: '金额',
  freightDiscountCol: '优惠金额',
  dispatchChangeHeadOffice: '样机、订阅卡、配件，请选择【总部发货】',
  dispatchChangeConfirmHeadOffice: '是否变更发货方式为：【总部发货】？',
  dispatchChangeLimitHeadOffice: '该限量机型，请选择【总部发货】',
  dispatchChangeConfirmLimitHeadOffice: '是否变更发货方式为：【总部发货】？',
  dispatchChangeRegion: '学习机，智学笔等正价商品，请选择【区域代理发货】',
  dispatchChangeConfirmRegion: '是否变更发货方式为：【区域代理发货】？',
  dialogTitleTip: '提示',
  dialogTitleConfirm: '确认',
  confirmDeleteContent: '确认删除吗？',
  priceRiseCycleTip: '您目前处在涨价周期内，请支付该订单的涨价部分，共{amount}元，此赊货订单才能进入后续审核环节！',
  saveSuccessExclaim: '保存成功!',
  cancelSaveMsg: '已取消保存',
  // addClassModal 添加商品弹窗
  productInstruction: '产品说明书',
  unitPriceShort: '单价',
  viewAction: '查看',
  suggestedRetailPrice: '（建议零售价：{price}元）',
  // DoubleOrderCreation 双重订单创建
  isDualOrderLabel: '是否双重订单：',
  relatedAgentLabel: '关联代理商：',
  placeholderRelatedAgent: '请选择关联代理商',
  placeholderFilterAgent: '请输入代理商ID或名称筛选',
  ruleRelatedAgentRequired: '请选择关联代理商',
  dualOrderYesDefault: '是',
  // SecondmentDetails 调货详情
  applicationNoLabel: '申请单编号：',
  applicantAgentLabel: '申请代理商：',
  receiveRegionAgentLabel: '收货区代：',
  inventoryQty: '库存量',
  // CloudStorageFlow 云仓流水
  storageFlowWarehouseLabel: '所属仓库',
  placeholderStorageFlowWarehouse: '请选择所属仓库',
  storageFlowCompleteTimeLabel: '完成时间',
  storageFlowModelTypeLabel: '商品类型',
  placeholderStorageFlowModelType: '请选择商品类型',
  storageFlowOrderInfoLabel: '单号信息',
  placeholderStorageFlowOrderInfo: '请输入单号信息',
  storageFlowBusinessTypeLabel: '业务类型',
  placeholderStorageFlowBusinessType: '请选择业务类型',
  storageInbound: '入库',
  storageOutbound: '出库',
  storageFlowWarehouseNameCol: '仓库名称',
  storageFlowOrderInfoCol: '单号信息',
  storageFlowTransferNoCol: '调拨单号',
  storageFlowProductNameCol: '商品名称',
  storageFlowPurchaseQtyCol: '采购数量',
  storageFlowInCountCol: '入库数量',
  storageFlowOutCountCol: '出库数量',
  storageFlowReceiveAgentIdCol: '收货代理商ID',
  storageFlowReceiveAgentNameCol: '收货代理商名称',
  storageFlowShipAgentIdCol: '发货代理商ID',
  storageFlowShipAgentNameCol: '发货代理商名称',
  storageFlowCompleteTimeCol: '完成时间',
  storageFlowInboundTotal: '入库数量',
  storageFlowOutboundTotal: '出库数量',
  exportUrlNotExist: '导出地址不存在',
  // AllocationCreation / DeliveryCreation
  outCampusIdLabel: '调出代理商ID：',
  outCampusNameLabel: '调出代理商名称：',
  outWarehouseLabel: '调出仓库：',
  inCampusIdLabel: '调入代理商ID：',
  inCampusNameLabel: '调入代理商名称：',
  inWarehouseLabel: '调入仓库：',
  relationTransferLabel: '关联调拨单：',
  placeholderSelectOutWarehouseFirst: '请选择调出仓库并输入调入代理商ID',
  ruleOutWarehouseRequired: '请选择调出仓库',
  ruleInCampusIdRequired: '请输入调入代理商ID',
  ruleInWarehouseRequired: '请选择调入仓库',
  warehouseAvailableInventoryCol: '仓库可用库存',
  transferNumCol: '调拨数量',
  extractNumColShort: '提货数量',
  // AllocationDetail 调拨详情
  orderStatusCol: '单据状态',
  cloudWarehouseTransferNoLabel: '云仓库调拨单号：',
  sendStatusCol: '发货状态',
  transferOutInfo: '调出信息',
  transferInInfo: '调入信息',
  productInfoLabel: '商品信息',
  logisticsInfoLabel: '物流信息',
  sendDateCol: '发货日期',
  sendQtyCol: '发货数量',
  msgWarehouseInOutMismatch: '调入仓库和调出仓库不一致',
  msgSelectWarehouseFirst: '请选择仓库信息',
  msgTransferNumExceedInventory: '调拨数量不能大于仓库可用库存',
  msgExtractNumExceedInventory: '提货数量不能大于仓库可用库存',
  msgAddressMin8Chars: '收货地址不满8个汉字，请修改',
  ruleWarehouseBelongRequired: '请选择所属仓库',

  // CloudStorageDetail 云仓入库明细
  modelTypeLabel: '商品类型',
  placeholderModelType: '请选择商品类型',
  inboundWarehouseLabel: '入库仓库',
  placeholderInboundWarehouse: '请选择入库仓库',
  inboundTimeLabel: '入库时间',
  deviceSnCodeLabel: '设备SN码',
  cloudStorageDetailOrderNoLabel: '订单单号',
  placeholderCloudStorageDetailOrderNo: '请输入订单单号',

  // CloudDeliveryOrder 云仓发货顺序
  warehouseShippingSeqTitle: '仓库发货顺序',
  warehouseShippingSeqTip: '默认发货仓的库存不足时，会按顺序依次检索其他仓库的库存发货。默认发货仓的变更会影响客户到付运费结算，请酌情调整。',
  defaultWarehouseLabel: '默认发货仓',
  modifyRecordTitle: '修改记录',
  operatorLabel: '操作人：',
  modifyTimeLabel: '修改时间：',
  afterModifyWarehouseSeq: '修改后仓库发货顺序',
  beforeModifyWarehouseSeq: '修改前仓库发货顺序',
  getDetailFailed: '获取详情失败',
  operatorCol: '操作人',

  // Procure1Pay 支付账户
  purchaseOrderNoColon: '采购单号：',
  orderTimeColon: '下单时间：',
  purchaseQtyColon: '采购量：',
  purchaseAmountColon: '采购金额：',
  paidAmountColon: '实付金额：',
  maxDeductible: '最高可抵扣：',

  // SchoolApplication 学校申报
  schoolName: '学校名称',
  schoolNamePlaceholder: '请输入学校名称',
  schoolNameTip: '请输入完整的公校名称，不要使用简称或随略语',
  provinceCityDistrictLabel: '所在省市区',
  provinceCityDistrictPlaceholder: '请选择省市区',
  detailAddressLabel: '详细地址',
  detailAddressPlaceholder: '请输入详细地址',
  schoolStage: '公校学段',
  studentScale: '在校人数规模',
  remarkOptional: '选填',
  submitNow: '立即申报',
  stagePrimary: '小学',
  stageJunior: '初中',
  stageSenior: '高中',
  stageOther: '其他',
  scaleUnder2000: '2000人以下',
  scale2000To4000: '2000~4000人',
  scale4000To6000: '4000~6000人',
  scaleOver6000: '6000人以上',
  scaleUnknown: '我不清楚',
  // StoreMap 门店地图
  storeMapLoadingText: '正在加载数据，马上呈现～',
  storeMapCurrentViewport: '当前视图范围：',
  storeMapClickToSwitchCity: '点击切换城市',
  storeMapSearchPlaceholder: '搜索位置',
  storeMapSchoolDeclare: '学校申报',
  storeMapStoreSuffix: '门店',
  storeMapIdLabel: 'ID：',
  storeMapLinkedSchoolLabel: '关联学校：',
  storeMapInvestorContactLabel: '投资人联系方式：',
  storeMapYearSuffix: '年',
  storeMapNoContent: '暂无内容',
  storeMapSchoolLocked: '该公校已被锁定',
  storeMapCanLockSchool: '可锁定该公校',
  storeMapPeopleSuffix: '人',
  storeMapSubmitSuccess: '提交成功',
  storeMapSubmitFailed: '提交失败',
  storeMapOperationFailedRetry: '操作失败，请稍后重试',
  storeMapNationwide: '全国',
  storeMapNoMatchingResult: '无匹配结果',
  storeMapFetchDataFailed: '获取数据异常',
  storeMapStoreCountUnit: '家',
  storeMapImageTypeDoor: '门头',
  storeMapImageTypeContract: '合同',
  storeMapImageTypeEnvironment: '环境',
  storeMapImageTypeFrontDesk: '前台',
  storeMapImageTypeVideo: '视频',
  storeMapImageTypeStore: '门店',
  storeMapSubmitDataErrorLog: '提交学校申报数据错误:',
  storeMapReverseGeocodeFailed: '百度地图逆地址解析坐标失败！',
  storeMapBurialPointName: '代理商门店地图',
}
